import React, { useEffect, useState } from "react";
import DefaultLayout from "../../layouts/defaultLayout";
import BurdCrumbs from "../../components/burdCrumbs";
import {
  Link,
  NavLink,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { settingsSideNavData } from "../../data/side_nav_data";
import { BASE_URL } from "../../constants";
import axios from "axios";
import { Loader } from "rsuite";
import { userData } from "../../data/fake_login_data";
import { toast } from "react-toastify";

const Settings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState({});
  if (location?.pathname === "/settings") {
    navigate("TTS");
  }

  const [data, setData] = useState(null);
  const fetchData = () => {
    axios
      .post(BASE_URL + "settings/select_setting.php", {
        admin_id: userData?.user_id,
        access_token: userData?.access_token,
      })
      .then((res) => {
        setData(res?.data?.message[0]);
      })
      .catch((err) => {
        setData({});
      });
  };

  const updateSettings = () => {
    setLoading({ type: "updateSettings", status: true });
    axios
      .post(BASE_URL + "settings/update_setting.php", {
        admin_id: userData?.user_id,
        access_token: userData?.access_token,
        ...data,
      })
      .then((res) => {
        if (res?.data?.status == "success") {
          toast.success("Updated");
          setLoading({});
          fetchData();
        } else {
          toast.success(res?.data?.message);
          setLoading({});
        }
      })
      .catch((err) => {
        setData({});
        setLoading({});
      });
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div id="home" className="min-h-screen bg-gradient-to-br from-indigo-50 to-blue-100">
      <DefaultLayout
        children={
          <div className="max-w-9xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className="flex flex-col md:flex-row">
              <aside className="w-full md:w-64 bg-indigo-800 text-white p-6">
                {settingsSideNavData && settingsSideNavData?.length ? (
                  <>
                    <BurdCrumbs title={"Settings"} />
                    <ul className="mt-8 space-y-4">
                      {settingsSideNavData.map((item, index) => {
                        return (
                          <li key={index}>
                            {!item?.subLinks && !item?.subLinks?.length ? (
                              <Link
                                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition duration-200 ${
                                  location?.pathname?.includes(item?.path)
                                    ? "bg-indigo-600 text-white shadow-md"
                                    : "hover:bg-indigo-700 hover:text-white text-white"
                                }`}
                                to={item?.path}
                              >
                                <span>{item?.icon}</span>
                                <span className="font-medium">{item?.label}</span>
                              </Link>
                            ) : (
                              <a className="flex items-center gap-3 px-4 py-3 rounded-lg hover:bg-indigo-700 transition duration-200 cursor-pointer">
                                <span>{item?.icon}</span>
                                <span className="font-medium">{item?.label}</span>
                              </a>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : null}
              </aside>
              <div className="flex-1 p-8">
                <h1 className="text-3xl font-bold text-indigo-800 mb-8">TTS Settings</h1>
                {!data ? (
                  <div className="flex justify-center items-center h-40">
                    <Loader />
                  </div>
                ) : data && Object?.values(data)?.length ? (
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      return loading?.type == "updateSettings" &&
                        loading?.status
                        ? null
                        : updateSettings();
                    }}
                    className="space-y-8"
                  >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                      <div className="bg-indigo-50 p-6 rounded-xl shadow-md">
                        <h2 className="text-xl font-semibold text-indigo-700 mb-4">Android & Huawei</h2>
                        <div className="space-y-4">
                          <div>
                            <label htmlFor="tts_interval" className="block text-sm font-medium text-gray-700 mb-1">TTS Interval</label>
                            <input
                              type="number"
                              value={data?.tts_interval}
                              onChange={(e) =>
                                setData({ ...data, tts_interval: e.target.value })
                              }
                              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                            />
                          </div>
                          <div>
                            <label htmlFor="tts_speed" className="block text-sm font-medium text-gray-700 mb-1">TTS Speed</label>
                            <input
                              type="number"
                              value={data?.tts_speed}
                              onChange={(e) =>
                                setData({ ...data, tts_speed: e.target.value })
                              }
                              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                            />
                          </div>
                          <div>
                            <label htmlFor="tts_sound_val" className="block text-sm font-medium text-gray-700 mb-1">TTS Sound Value</label>
                            <input
                              type="number"
                              value={data?.tts_sound_val}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  tts_sound_val: e.target.value,
                                })
                              }
                              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="bg-blue-50 p-6 rounded-xl shadow-md">
                        <h2 className="text-xl font-semibold text-blue-700 mb-4">iOS</h2>
                        <div className="space-y-4">
                          <div>
                            <label htmlFor="tts_interval_ios" className="block text-sm font-medium text-gray-700 mb-1">TTS Interval</label>
                            <input
                              type="number"
                              value={data?.tts_interval_ios}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  tts_interval_ios: e.target.value,
                                })
                              }
                              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                            />
                          </div>
                          <div>
                            <label htmlFor="tts_speed_ios" className="block text-sm font-medium text-gray-700 mb-1">TTS Speed</label>
                            <input
                              type="number"
                              value={data?.tts_speed_ios}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  tts_speed_ios: e.target.value,
                                })
                              }
                              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                            />
                          </div>
                          <div>
                            <label htmlFor="tts_sound_val_ios" className="block text-sm font-medium text-gray-700 mb-1">TTS Sound Value</label>
                            <input
                              type="number"
                              value={data?.tts_sound_val_ios}
                              onChange={(e) =>
                                setData({
                                  ...data,
                                  tts_sound_val_ios: e.target.value,
                                })
                              }
                              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <button 
                        type="submit"
                        className="px-8 py-3 bg-indigo-600 text-white font-bold rounded-full shadow-md hover:bg-indigo-700 hover:shadow-lg transition duration-300 transform hover:-translate-y-1 flex items-center gap-2"
                      >
                        {loading?.type == "updateSettings" && loading?.status ? (
                          <Loader />
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </form>
                ) : (
                  <h3 className="text-xl text-gray-600 text-center mt-10">No Settings Available</h3>
                )}
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default Settings;